import { api } from './api';

export interface Categoria {
  id: number;
  tenantId: number;
  name: string;
  description?: string;
  parentId?: number;
  isActive: boolean;
  parent?: Categoria;
  children?: Categoria[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CategoriaCreate {
  name: string;
  description?: string;
  parentId?: number;
  tenantId?: number;
}

export interface CategoriaUpdate {
  name?: string;
  description?: string;
  parentId?: number;
  isActive?: boolean;
}

export interface CategoriasResponse {
  success: boolean;
  data: {
    categorias: Categoria[];
  };
}

export interface CategoriaResponse {
  success: boolean;
  data: {
    categoria: Categoria;
  };
}

export const categoriaService = {
  getAll: async (tenantId?: number, parentId?: number | null): Promise<Categoria[]> => {
    const params = new URLSearchParams();
    if (tenantId) params.append('tenantId', tenantId.toString());
    if (parentId !== undefined) params.append('parentId', parentId === null ? 'null' : parentId.toString());
    
    const response = await api.get<CategoriasResponse>(`/categorias?${params}`);
    return response.data.data.categorias;
  },

  getById: async (id: number): Promise<Categoria> => {
    const response = await api.get<CategoriaResponse>(`/categorias/${id}`);
    return response.data.data.categoria;
  },

  create: async (data: CategoriaCreate): Promise<Categoria> => {
    const response = await api.post<CategoriaResponse>('/categorias', data);
    return response.data.data.categoria;
  },

  update: async (id: number, data: CategoriaUpdate): Promise<Categoria> => {
    const response = await api.put<CategoriaResponse>(`/categorias/${id}`, data);
    return response.data.data.categoria;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/categorias/${id}`);
  }
};

